<template>
  <div class="page">
    <YorkbbsHeader>
      <el-breadcrumb-item slot="home" :to="{ name: 'Home' }">
        <i class="yk-home"></i>
        <span>约克黄页</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>发布黄页</el-breadcrumb-item>
    </YorkbbsHeader>

    <div class="main">
      <!-- 发布成功提示 -->
      <div class="success-tip">
        <i class="el-icon-success"></i>
        <span>发布成功</span>
      </div>

      <!-- 发布成功文字描述 -->
      <!-- 免费 -->
      <div class="success-tip__text" v-if="!payTypes.includes(1) && !payTypes.includes(2) && payTypes.includes(4)">
        <template v-if="needAudit">
          该黄页为免费栏目，需要审核后才能公开发布。目前您的黄页处于隐藏中，仅自己可见。
        </template>
        <template v-else>
          您的信息已公开发布，如需推广请联系客服。
        </template>
      </div>
      <div class="success-tip__text" v-else>
        该黄页为付费栏目，定制广告后才能公开发布。目前您的黄页处于隐藏中，仅自己可见。
      </div>

      <!-- 操作按钮 -->
      <div class="tools">
        <!-- 时长付费、开始在线付费 -->
        <div class="tool" v-if="!payTypes.includes(1) && payTypes.includes(2) && enableOnlinePay">
          <el-popover trigger="hover" placement="bottom" :width="840">
            <el-button size="small" type="primary" slot="reference">我要推广</el-button>

            <!-- 时长付费套餐 -->
            <div class="card">
              <!-- 头部 -->
              <div class="card-header">
                <!-- 标题 -->
                <div class="card-header__name">购买广告 快速提升浏览量</div>
                <!-- 提示 -->
                <div class="card-header__tip">
                  注：广告类型为时长广告，购买的时间越长，广告到期日期越晚，列表中排序越靠前，曝光率更高。
                </div>
              </div>

              <!-- 列表 -->
              <el-radio-group class="pay-list" v-model="radioIndex">
                <!-- 快捷套餐 -->
                <el-radio class="pay-item" v-for="(item, i) in buyPlans" :key="i" :label="i">
                  <div class="pay-price">
                    <span class="pay-symbol">$</span>
                    <span class="pay-num">{{ item.totalMoney | moneyFormat }}</span>
                  </div>
                  <div class="pay-give">{{ item.introduce }}</div>
                  <div class="pay-tip">{{ item.remark }}</div>
                  <div class="pay-label" v-if="item.defaultPlan == 1">推荐</div>
                </el-radio>
                <!-- 更多套餐 -->
                <el-radio class="pay-item" :label="3">
                  <div>
                    <el-select class="pay-select" v-model="otherPlanIndex" @focus="radioIndex = 3">
                      <el-option
                        v-for="(item, i) in otherPlans"
                        :key="i"
                        :label="item.buyMonths / 12"
                        :value="i"
                      ></el-option>
                    </el-select>
                    <span class="pay-unit__year">年</span>
                  </div>
                  <div class="pay-selected">{{ otherPlainRemark }}</div>
                </el-radio>
              </el-radio-group>

              <!-- 底部 -->
              <div class="card-footer">
                <!-- 合计 -->
                <div class="pay-count">
                  <span>共</span>
                  <strong>{{ totalMonth }}个月，</strong>
                  <span>合计</span>
                  <strong>${{ totalMoney | moneyFormat }}</strong>
                </div>
                <el-button class="pay-button" type="primary" :loading="submitLoading" @click="submitOrder"
                  >定制广告</el-button
                >
              </div>
            </div>
          </el-popover>
        </div>
        <div class="tool" v-else>
          <YorkbbsServerPopover placement="bottom">
            <el-button size="small" type="primary">我要推广</el-button>
          </YorkbbsServerPopover>
        </div>
        <a class="tool" :href="`/detail/${$route.params.id}` | hostBuild('merchant')">
          <el-button size="small">黄页管理</el-button>
        </a>
        <router-link class="tool" :to="detailUrl">
          <el-button size="small">查看黄页</el-button>
        </router-link>
        <router-link class="tool" :to="`/publish?id=${$route.params.id}`">
          <el-button size="small">编辑</el-button>
        </router-link>
      </div>

      <!-- 右侧悬浮 -->
      <div class="fixation">
        <YorkbbsServerPopover placement="left">
          <div class="fixation-item">
            <i class="yk-kefu"></i>
          </div>
        </YorkbbsServerPopover>
      </div>
    </div>
  </div>
</template>
<script>
import YorkbbsHeader from '@/common/header/header-simple.vue';
import YorkbbsServerPopover from './popover-server.vue';
import { hostBuild } from '@/utils/utils';
export default {
  name: 'Success',
  components: { YorkbbsHeader, YorkbbsServerPopover },
  data() {
    return {
      // 付费信息加载状态
      loading: false,
      // 付费类型
      payTypes: [],
      // 是否启用在线付费
      enableOnlinePay: 0,
      // 时长付费套餐
      buyPlans: [],
      // 时长付费更多套餐
      otherPlans: [],

      // 选中的单选框索引
      radioIndex: 0,
      // 其他套餐的索引
      otherPlanIndex: 0,

      // 提交加载状态
      submitLoading: false,

      // 板块英文短名
      topicEnglishName: '',

      // 是否需要审核
      needAudit: 0,
      merchantId:'',
      businessType:{}
    };
  },
  computed: {
    // 其他套餐的描述信息
    otherPlainRemark() {
      if (this.otherPlans.length == 0) return '';
      return this.otherPlans[this.otherPlanIndex]['remark'];
    },
    // 购买的的套餐ID
    buyPlanId() {
      if (this.radioIndex == 3) return this.otherPlans[this.otherPlanIndex]['id'];
      return this.buyPlans[this.radioIndex]['id'];
    },
    // 共计月数
    totalMonth() {
      if (this.radioIndex == 3) {
        if (this.otherPlans.length == 0) return '';
        return this.otherPlans[this.otherPlanIndex]['buyMonths'] + this.otherPlans[this.otherPlanIndex]['giveMonths'];
      } else {
        if (this.buyPlans.length == 0) return '';
        return this.buyPlans[this.radioIndex]['buyMonths'] + this.buyPlans[this.radioIndex]['giveMonths'];
      }
    },
    // 共计钱数
    totalMoney() {
      if (this.radioIndex == 3) {
        if (this.otherPlans.length == 0) return '';
        return this.otherPlans[this.otherPlanIndex]['totalMoney'];
      } else {
        if (this.buyPlans.length == 0) return '';
        return this.buyPlans[this.radioIndex]['totalMoney'];
      }
    },
    detailUrl(){
      if( this.businessType.id == 3){
        return `/${this.businessType.name_en}/${this.topicEnglishName}/${this.merchantId}`
      }else{
        return `/detail/${this.topicEnglishName}/${this.$route.params.id}`
      }
    }
  },
  created() {
    this.getPostPayInfo();
  },
  methods: {
    /**
     * 获取付费信息
     */
    async getPostPayInfo() {
      this.loading = true;
      const { data } = await this.$axios
        .post('/info/v1/get/topic/by/postid', {
          postId: this.$route.params.id,
        })
        .finally(() => {
          this.loading = false;
        });

      this.payTypes = data.payTypes;
      this.needAudit = data.needAudit;
      this.enableOnlinePay = data.enableOnlinePay;
      this.buyPlans = data?.durationBuyPlan?.buyPlans || [];
      this.otherPlans = data?.durationBuyPlan?.otherPlans || [];
      this.topicEnglishName = data.englishName;
      this.merchantId = data.merchantId;
      this.businessType = data.businessType||{};


      this.radioIndex = this.buyPlans.findIndex(item => item.defaultPlan == 1) || 0;
    },
    /**
     * 提交订单
     */
    async submitOrder() {
      // orderNo: "OD2000014417"
      this.submitLoading = true;
      const { data } = await this.$axios
        .post('/bank/v1/create/online/duration/order', {
          postId: this.$route.params.id,
          planId: this.buyPlanId,
        })
        .finally(() => {
          this.submitLoading = false;
        });
      const url = hostBuild(`/pay/${data.orderNo}`, 'bank');
      window.open(url);
    },
  },
};
</script>
<style lang="scss" scoped>
.page {
  min-height: 100vh;
  background-color: #f8f8f8;
  display: flex;
  flex-direction: column;
}

.main {
  flex: 1;
  height: 0;
  padding: 50px 0;
}

.success-tip {
  text-align: center;
  padding-top: 50px;
  padding-bottom: 15px;
  i {
    font-size: 30px;
    color: var(--primary-color);
    vertical-align: middle;
    margin-right: 5px;
  }
  span {
    font-size: 20px;
    font-weight: 500;
    vertical-align: middle;
  }
}

.success-tip__text {
  text-align: center;
  font-size: 14px;
  line-height: 20px;
  color: var(--text-color-6);
  margin-top: 20px;
  margin-bottom: 26px;
}

.tools {
  display: flex;
  justify-content: center;
}
.tool {
  margin-right: 15px;
}

.fixation {
  position: absolute;
  left: calc(50% + 500px);
  bottom: 200px;
  z-index: 9;
  overflow: hidden;
  border: 1px solid #eeeeee;
  border-radius: 6px;
}
.fixation-item {
  width: 60px;
  height: 60px;
  background: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  user-select: none;
  font-size: 20px;
}

.card {
  box-sizing: border-box;
  width: 840px;
  padding: 40px 50px;

  margin: auto;

  border-radius: 6px;
  background: #ffffff;
}

.card-header {
  padding-bottom: 36px;
}

.card-header__name {
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  padding-bottom: 10px;
}

.card-header__tip {
  font-size: 12px;
  color: var(--text-color-9);
  line-height: 17px;
}

.pay-list {
  display: flex;
  justify-content: space-between;
  padding-bottom: 50px;
}

.pay-item {
  margin-right: 0;

  ::v-deep {
    .el-radio__input {
      display: none;
    }
    .el-radio__label {
      border-radius: 6px;

      box-sizing: border-box;
      width: 170px;
      height: 144px;
      border: 1px solid #dfe0e1;
      padding-left: 0;

      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      position: relative;
    }
  }

  &.is-checked {
    ::v-deep {
      .el-radio__label {
        border-color: #f4d49b;
        background-color: #fdf8eb;
        background-image: url('~@/assets/images/info/checked.png');
        background-repeat: no-repeat;
        background-position: right bottom;
      }
      .el-input__inner {
        background-color: #fff;
        border-color: #fff;
      }
    }
  }
}

.pay-symbol {
  font-size: 18px;
  font-weight: 600;
  color: #5c3600;
  line-height: 25px;
  vertical-align: middle;
  padding-right: 6px;
}
.pay-num {
  font-size: 40px;
  font-weight: 500;
  color: #5c3600;
  line-height: 56px;
  vertical-align: middle;
}

.pay-give {
  line-height: 30px;
  background: #e6b475;
  border-radius: 6px;
  padding: 0 12px;
  font-size: 14px;
  color: #fff;
  margin-bottom: 10px;
}

.pay-tip {
  font-size: 12px;
  color: var(--text-color-9);
  line-height: 17px;
}

.pay-label {
  line-height: 30px;
  padding: 0 12px;

  background: var(--primary-color);
  border-radius: 0px 10px 0px 10px;
  color: #fff;
  font-size: 14px;

  position: absolute;
  left: 0;
  top: -16px;
  z-index: 1;
}

.pay-select {
  width: 100px;
  ::v-deep {
    .el-input__inner {
      background-color: #f8f8f8;
      border-color: #f8f8f8;
      font-size: 18px;
    }
  }
}

.pay-unit__year {
  font-size: 14px;
  color: #5c3600;
  line-height: 20px;
  margin-left: 16px;
}

.pay-selected {
  font-size: 14px;
  line-height: 20px;
  height: 20px;
  padding-top: 10px;
  color: var(--text-color);
}

.card-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.pay-count {
  color: var(--text-color-3);
  padding-right: 30px;
  span {
    font-size: 16px;
    margin-right: 5px;
    vertical-align: middle;
  }
  strong {
    font-weight: 600;
    font-size: 20px;
    vertical-align: middle;
  }
}

.pay-button {
  width: 200px;
  height: 50px;
  padding: 0;
  font-size: 20px;
}
</style>
